import { locale } from '@trqk/utils';

export const shortLabels = {
    all: locale.enUS.ALL_STATEMENTS,
    checked: locale.enUS.SELECTED_STATEMENTS,
    international: locale.enUS.INTERNATIONAL_STATEMENTS,
    lastTwo: locale.enUS.LAST_TWO_STATEMENTS,
    selected: locale.enUS.CHECKED_STATEMENTS,
    standard: locale.enUS.STANDARD_STATEMENTS,
    unfiltered: locale.enUS.UNFILTERED_STATEMENTS,
    yearToDate: locale.enUS.YEAR_TO_DATE_STATEMENTS,
};
